export default "__VITE_ASSET__DNnNPxDa__"